import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface InitialAccountStateI {
  authToken: string | null;
  error: string | null;
}

const initialState: InitialAccountStateI = {
  authToken: null,
  error: null,
};

const accountSlice = createSlice({
  name: "account",
  initialState,
  reducers: {
    setAuthToken(state, action: PayloadAction<string | null>) {
      state.authToken = action.payload;
      state.error = null;
    },
    clearAuthToken(state) {
      state.authToken = null;
    },
    setAuthError(state, action: PayloadAction<string>) {
      state.error = action.payload;
    },
    clearAuthError(state) {
      state.error = null;
    },
  },
});

export const {
  setAuthToken,
  setAuthError,
  clearAuthError,
  clearAuthToken
} = accountSlice.actions;

export default accountSlice.reducer;
